import { createAsyncThunk } from '@reduxjs/toolkit'
import { SOMETHING_WHEN_WRONG } from 'constant/errorMessages'
import { callErrorMsg } from 'helpers/errorMsg'
import { downloadFileBlob } from 'utils/downloadFileUrl'
import {
  deleteSOScheduleByIdAPI,
  downloadSOSchedulesCsvAPI,
  downloadSOScheduleDestinationsCsvAPI,
  DownloadSOSchedulesCsvRequestType,
  DownloadSOScheduleDestinationsCsvRequestType,
  getSOSchedulesListAPI,
  getSOScheduleDestinationsAPI,
  getSOSchedulesOriginLocationsAPI,
  getSupplyOrderRemarksAPI,
  runSOScheduleNowAPI,
  GetSOScheduleDestinationsRequestType,
  GetSOSchedulesListRequestType,
} from '../../services/soSchedules'

export const SLICE_NAME = 'SO_SCHEDULES'

export const fetchGetSOSchedules = createAsyncThunk(
  `${SLICE_NAME}/fetchGetSOSchedules`,
  async (params: GetSOSchedulesListRequestType, { rejectWithValue }) => {
    try {
      const response = await getSOSchedulesListAPI(params)

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchDeleteSOScheduleById = createAsyncThunk(
  `${SLICE_NAME}/fetchDeleteSOScheduleById`,
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await deleteSOScheduleByIdAPI(id)

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchGetSOSchedulesOriginLocations = createAsyncThunk(
  `${SLICE_NAME}/fetchGetSOSchedulesOriginLocations`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSOSchedulesOriginLocationsAPI()

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchGetSupplyOrderRemarks = createAsyncThunk(
  `${SLICE_NAME}/fetchGetSupplyOrderRemarks`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSupplyOrderRemarksAPI()

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchDownloadSOSchedulesCsv = createAsyncThunk(
  `${SLICE_NAME}/fetchDownloadSOSchedulesCsv`,
  async (params: DownloadSOSchedulesCsvRequestType, { rejectWithValue }) => {
    try {
      const response = await downloadSOSchedulesCsvAPI(params)
      if (response.data.chunk_data) {
        downloadFileBlob({
          data: response.data.chunk_data,
          fileName: 'so-schedules.csv',
          mimeType: 'text/csv',
        })
      }
      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchDownloadSOScheduleDestinationsCsv = createAsyncThunk(
  `${SLICE_NAME}/fetchDownloadSOScheduleDestinationsCsv`,
  async (params: DownloadSOScheduleDestinationsCsvRequestType, { rejectWithValue }) => {
    try {
      const response = await downloadSOScheduleDestinationsCsvAPI(params)
      if (response.data.chunk_data) {
        downloadFileBlob({
          data: response.data.chunk_data,
          fileName: 'so-schedule-destinations.csv',
          mimeType: 'text/csv',
        })
      }
      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchRunSOScheduleNow = createAsyncThunk(
  `${SLICE_NAME}/fetchRunSOScheduleNow`,
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await runSOScheduleNowAPI(id)
      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchGetSOScheduleDestinations = createAsyncThunk(
  `${SLICE_NAME}/fetchGetSOScheduleDestinations`,
  async (
    props: { id: number; params?: GetSOScheduleDestinationsRequestType },
    { rejectWithValue },
  ) => {
    try {
      const { id, params } = props

      const response = await getSOScheduleDestinationsAPI(id, params || {})
      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)
